<template>
  <div class="sm-layout">
    <div v-if="loading" class="w-full h-full flex justify-center items-center">
      <s-loader size="small" label="Cargando ..."></s-loader>
    </div>
    <Transition>
      <slot v-if="!loading"></slot>
    </Transition>
    <FooterComponent></FooterComponent>
  </div>
</template>
<script lang="ts" setup>
import { SLoader } from '@alegradev/smile-ui-next'
import { useAppStore } from 'app_alegra_commons/app'
import { computed, onBeforeMount } from 'vue'
import FooterComponent from '@/micro/components/footer/FooterComponent.vue'
import { convertDictionaryToObject } from '@/micro/utils/appHelpers'
import useMicrofront from '../composables/useMicrofront'

const { loadUserInfo, addToDictionary } = useMicrofront()

onBeforeMount(async () => {
  APP.globalLoading = true
  const dictObjConverted = convertDictionaryToObject()
  try {
    console.log(dictObjConverted)
    await loadUserInfo(dictObjConverted)
  } catch (error) {
    console.error('Error loading user info: ', error)
    // Definición del diccionario cuando no está loguead
    addToDictionary(dictObjConverted)
  } finally {
    APP.globalLoading = false
  }
})

const APP = useAppStore()

const loading = computed(() => {
  return Boolean(APP.globalLoading)
})
</script>
<style lang="scss" scoped>
.sm-layout {
  display: grid;
  grid-template-rows: 1fr auto;
  position: relative;
  height: 100vh;
  main {
    @apply w-full;
  }
}

.v-enter-active {
  transition: opacity 2s ease;
}
.v-leave-active {
  transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
